export default function TypingSendingManager(chatRoom) {
  this.interval = undefined;

  // Adding a listener to the Chat Input to send a typing signal
  // every two seconds of typing.
  $("#comment-input")
    .on("focus", () => {
      this.interval = setInterval(() => {
        if ($("#comment-input").html().trim()) {
          chatRoom.typing();
        }
      }, 2000);
    })
    .on("blur", this.editorSelector, () => {
      // Stop sending typing signal if the input isn't focused anymore.
      clearInterval(this.interval);
    });
}
